import withSlice from '@screens/SlicesContainer/withSlice';
import { mapRichTextZone } from './mapRichTextZone';
import { IRichTextZone } from './types';
import { PrismicRichText } from '@components/PrismicRichText';
import type { JSX } from "react";
/**
 * Component for "RichTextZone" Slices.
 */
const DefaultRichTextZone = ({ content, className }) => (
  <section className={className}>
    <PrismicRichText field={content} />
  </section>
);
const VariationDefault = ({ content }): JSX.Element => (
  <DefaultRichTextZone
    content={content}
    className="rich-text-zone tw-lf-rich-text"
  />
);

const VariationSecondaryRichTextZone = ({ content }): JSX.Element => (
  <DefaultRichTextZone
    content={content}
    className="rich-text-zone tw-mf-body-bold tw-lf-secondary-rich-text"
  />
);

const VariationRichTextSmall = ({ content }): JSX.Element => (
  <DefaultRichTextZone
    content={content}
    className="rich-text-zone tw-lf-rich-text-small"
  />
);

const RichTextZone = ({ content, ...props }: IRichTextZone): JSX.Element => {
  switch (props.variation) {
    case 'secondaryRichTextZone':
      return <VariationSecondaryRichTextZone {...props} content={content} />;
    case `smallTextRichTextZone`:
      return <VariationRichTextSmall {...props} content={content} />;
    default:
      return <VariationDefault {...props} content={content} />;
  }
};

export default withSlice(RichTextZone, mapRichTextZone);
